import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that checks if a value is in the specified step increments (e.g., 0.5)
 * Example: stepValidator(0.5) will validate values like 1.0, 1.5, 2.0, 2.5, etc.
 * and reject values like 1.1, 1.2, 1.34, etc.
 *
 * @param step The increment step to validate (e.g., 0.5 for half increments)
 * @returns ValidatorFn that validates the step increment
 */
export function stepValidator(step: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value == null || value === '') {
      return null;
    }
    const numValue = Number(value);
    if (Number.isNaN(numValue)) {
      return null;
    }
    const remainder = (numValue * 100) % (step * 100);
    return Math.abs(remainder) < 0.01 ? null : { step: { requiredStep: step, actualValue: value } };
  };
}
